import React from "react";
import { FiClock, FiBriefcase, FiTarget } from "react-icons/fi";
import { LuBuilding2 } from "react-icons/lu";

const formatDateTime = (dateStr) => {
  if (!dateStr) return "-";
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;

  const day = String(d.getDate()).padStart(2, "0");
  const month = d.toLocaleString("default", { month: "short" });
  const year = d.getFullYear();
  const time = d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

  return `${day} ${month} ${year}, ${time}`;
};

const isTaskOverdue = (task) => {
  if (!task.due_date) return false;
  if (task.status === "Completed" || task.status === "Cancelled") return false;
  return new Date(task.due_date) < new Date();
};

export const taskColumns = ({
  selectedIds = [],
  handleSelect,
  handleSelectAll,
  totalRows = 0,
}) => [
  {
    id: "select",
    label: (
      <input
        type="checkbox"
        checked={totalRows > 0 && selectedIds.length === totalRows}
        onChange={handleSelectAll}
      />
    ),
    render: (row) => (
      <input
        type="checkbox"
        checked={selectedIds.includes(String(row.id))}
        onChange={() => handleSelect(row.id)}
        onClick={(e) => e.stopPropagation()}
      />
    ),
  },
  {
    id: "title",
    label: "Task",
    render: (row) => (
      <div className="task-title-cell">
        <div className="task-main-title" title={row.title}>
          {row.title}
        </div>
        {row.description && (
          <div className="task-sub-description" title={row.description}>
            {row.description}
          </div>
        )}
      </div>
    ),
    exportValue: (row) => row.title,
  },
  {
    id: "due_date",
    label: "Due Date",
    render: (row) => {
      if (!row.due_date) {
        return <span style={{ color: "#94a3b8", fontSize: "13px" }}>-</span>;
      }
      const overdue = isTaskOverdue(row);
      return (
        <div className={`task-due-date ${overdue ? "is-overdue" : ""}`}>
          <div className="task-due-date-value">
            <FiClock size={13} className="task-due-clock-icon" />
            <span>{formatDateTime(row.due_date)}</span>
          </div>
          {overdue && <span className="overdue-badge">OVERDUE</span>}
        </div>
      );
    },
    exportValue: (row) => formatDateTime(row.due_date),
  },
  {
    id: "related_to",
    label: "Related To",
    render: (row) => {
      if (row.deal_title) {
        return (
          <span className="task-entity-chip" title={`Deal: ${row.deal_title}`}>
            <FiBriefcase size={12} color="#16a34a" className="task-entity-icon" />
            <span className="task-entity-text">{row.deal_title}</span>
          </span>
        );
      }
      if (row.lead_title) {
        return (
          <span className="task-entity-chip" title={`Lead: ${row.lead_title}`}>
            <FiTarget size={12} color="#0284c7" className="task-entity-icon" />
            <span className="task-entity-text">{row.lead_title}</span>
          </span>
        );
      }
      if (row.organization_name) {
        return (
          <span className="task-entity-chip" title={`Org: ${row.organization_name}`}>
            <LuBuilding2 size={12} color="#9333ea" className="task-entity-icon" />
            <span className="task-entity-text">{row.organization_name}</span>
          </span>
        );
      }
      return <span style={{ color: "#94a3b8", fontSize: "13px" }}>-</span>;
    },
    exportValue: (row) =>
      row.deal_title || row.lead_title || row.organization_name || "",
  },
  {
    id: "assigned_user_name",
    label: "Assigned To",
    render: (row) => (
      <span
        className="task-assigned-user"
        title={row.assigned_user_name || "Unassigned"}
      >
        {row.assigned_user_name || "Unassigned"}
      </span>
    ),
    exportValue: (row) => row.assigned_user_name || "Unassigned",
  },
];
